import { useTranslation } from "react-i18next";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { ChangeEvent, FunctionComponent, KeyboardEvent } from "react";
import FormItemInput from "../../../../../../components/form-input/FormInput";

type FilterTableProps = {
  searchValue: string;
  handleOpenFilter: () => void;
  handleSubmitSearch: () => void;
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void;
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
};

const FilterTable: FunctionComponent<FilterTableProps> = ({
  searchValue,
  handleSearch,
  handleOpenFilter,
  handleChangeInput,
  handleSubmitSearch,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="filter-table-university">
        <div className="heading-item heading-filter">
          <Button className="filter-button" onClick={handleOpenFilter}>
            <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
            <DownOutlined />
          </Button>
        </div>
        <div className="heading-item heading-search">
          <FormItemInput
            placeholder={t("Nhập tên khóa học để tìm kiếm", "Nhập tên khóa học để tìm kiếm")}
            value={searchValue}
            onChange={handleChangeInput}
            onKeyPress={handleSearch}
            afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
          />
        </div>
      </div>
    </>
  );
};

export default FilterTable;